import { useAPI } from "@/hooks/useAPI";
import { addCaseQcReviewerToCache, removeCaseQcReviewerFromCache } from "@/hooks/useCases";
import type { CaseUser } from "@/services/caseServiceV2.types";
import { CaseUsersService } from "@/services/caseUsersService";
import { useCallback, useMemo } from "react";

export const useCaseQcReviewers = (caseId: string) => {
  const api = useAPI("v2");
  const caseUsersService = useMemo(() => new CaseUsersService(api), [api]);

  const addQcReviewer = useCallback(
    async (qcReviewer: CaseUser): Promise<void> => {
      await caseUsersService.addQcReviewer(caseId, qcReviewer.user_id);
      addCaseQcReviewerToCache(caseId, qcReviewer);
    },
    [caseUsersService, caseId]
  );

  const removeQcReviewer = useCallback(
    async (userId: string): Promise<void> => {
      await caseUsersService.removeQcReviewer(caseId, userId);
      removeCaseQcReviewerFromCache(caseId, userId);
    },
    [caseUsersService, caseId]
  );

  return { addQcReviewer, removeQcReviewer };
};
